import { GenIcon } from '../helpers/IconBase.es.js';

const ArrowDownFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M16.4767 10H7.52331C7.07668 10 6.83609 10.5267 7.12731 10.867L11.208 15.6348C11.6248 16.1217 12.3752 16.1217 12.792 15.6348L16.8727 10.867C17.1639 10.5267 16.9233 10 16.4767 10Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { ArrowDownFilled };
